import { render, staticRenderFns } from "./JoinGroup.vue?vue&type=template&id=1d6fb9da&scoped=true"
import script from "./JoinGroup.vue?vue&type=script&lang=js"
export * from "./JoinGroup.vue?vue&type=script&lang=js"
import style0 from "./JoinGroup.vue?vue&type=style&index=0&id=1d6fb9da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6fb9da",
  null
  
)

export default component.exports